"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scrollbar = exports.SCROLLBAR_SIZE = exports.Direction = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_measure_1 = __importDefault(require("react-measure"));
var Direction;
(function (Direction) {
    Direction[Direction["HORIZONTAL"] = 0] = "HORIZONTAL";
    Direction[Direction["VERTICAL"] = 1] = "VERTICAL";
})(Direction || (exports.Direction = Direction = {}));
exports.SCROLLBAR_SIZE = 10;
var ROUND_FACTOR = 4;
var Scrollbar = /** @class */ (function (_super) {
    __extends(Scrollbar, _super);
    function Scrollbar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            scrollbarSize: 0
        };
        return _this;
    }
    /**
     * Designed to be call by the parent component
     * (for example when parent component whats to implement scroll by touching the scrollable container on the mobile devices)
     *
     * @param delta
     */
    Scrollbar.prototype.scrollwithDelta = function (delta) {
        var unit_per_px = this.props.pageSize / this.state.scrollbarSize;
        var pixels_per_unit = this.state.scrollbarSize / this.props.pageSize;
        var scrollPositionInPixels = this.props.direction == Direction.HORIZONTAL ? this._outterDiv.scrollLeft : this._outterDiv.scrollTop;
        var scrollPosition = this.props.minScrollPosition + unit_per_px * scrollPositionInPixels;
        var newScrollPosition = scrollPosition + delta;
        if (newScrollPosition < this.props.minScrollPosition) {
            newScrollPosition = this.props.minScrollPosition;
        }
        else if (newScrollPosition > this.props.maxScrollPosition) {
            newScrollPosition = this.props.maxScrollPosition;
        }
        this.setScrollPositionInPx((newScrollPosition - this.props.minScrollPosition) * pixels_per_unit);
    };
    Scrollbar.prototype.componentDidMount = function () {
        if (this.props.onVisibilityChange) {
            this.props.onVisibilityChange(this.isScrollbarNeeded(this.props));
        }
    };
    Scrollbar.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.onVisibilityChange && this.isScrollbarNeeded(nextProps) != this.isScrollbarNeeded(this.props)) {
            nextProps.onVisibilityChange(this.isScrollbarNeeded(nextProps));
        }
        if (nextProps.minScrollPosition != this.props.minScrollPosition ||
            nextProps.maxScrollPosition != this.props.maxScrollPosition ||
            nextProps.pageSize != this.props.pageSize ||
            nextProps.scrollPosition != this.props.scrollPosition) {
            this.setScrollPosition(nextProps);
        }
    };
    Scrollbar.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (this.state.scrollbarSize != prevState.scrollbarSize) {
            this.setScrollPosition(this.props);
        }
    };
    Scrollbar.prototype.setScrollPosition = function (props) {
        var pixels_per_unit = this.state.scrollbarSize / props.pageSize;
        this.setScrollPositionInPx((props.scrollPosition - props.minScrollPosition) * pixels_per_unit);
    };
    Scrollbar.prototype.setScrollPositionInPx = function (scrollPositionInPixels) {
        if (!this._outterDiv) {
            return;
        }
        // We need this check because else a small flicker appears on the scrollbar when scrolling
        // a scrollbar that is "double binded" to a state variable in the parent component (e.g. in gantt)
        // It is caused by a small precision lost when converting from pixels to client unit and then back again
        var oldScrollPositionInPixels = this.props.direction == Direction.HORIZONTAL ? this._outterDiv.scrollLeft : this._outterDiv.scrollTop;
        if (roundDoubleToDecimals(scrollPositionInPixels) == roundDoubleToDecimals(oldScrollPositionInPixels)) {
            return;
        }
        if (this.props.direction == Direction.HORIZONTAL) {
            this._outterDiv.scrollLeft = scrollPositionInPixels;
        }
        else {
            this._outterDiv.scrollTop = scrollPositionInPixels;
        }
    };
    Scrollbar.prototype.onScroll = function () {
        var unit_per_px = this.props.pageSize / this.state.scrollbarSize;
        var scrollPositionInPixels = this.props.direction == Direction.HORIZONTAL ? this._outterDiv.scrollLeft : this._outterDiv.scrollTop;
        this.props.onScroll(this.props.minScrollPosition + unit_per_px * scrollPositionInPixels);
    };
    Scrollbar.prototype.getInnerDivSize = function () {
        var pixels_per_unit = this.state.scrollbarSize / this.props.pageSize;
        return (this.props.maxScrollPosition - this.props.minScrollPosition) * pixels_per_unit;
    };
    Scrollbar.prototype.isScrollbarNeeded = function (props) {
        return (props.maxScrollPosition - props.minScrollPosition) > props.pageSize;
    };
    Scrollbar.prototype.getOutterDivClassName = function () {
        var className = (this.props.direction == Direction.HORIZONTAL ? "rct9k-horizontal-scrollbar-outter" : "rct9k-vertical-scrollbar-outter");
        return className + (this.props.hasArrows ? " rct9k-scrollbar-with-arrows" : "");
    };
    Scrollbar.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var _a = this, props = _a.props, state = _a.state;
        if (nextProps.minScrollPosition !== props.minScrollPosition
            || nextProps.maxScrollPosition !== props.maxScrollPosition
            || nextProps.pageSize !== props.pageSize
            || nextProps.direction !== props.direction
            || nextProps.hasArrows !== props.hasArrows) {
            return true;
        }
        if (nextState.scrollbarSize !== state.scrollbarSize) {
            return true;
        }
        return false;
    };
    Scrollbar.prototype.render = function () {
        var _this = this;
        return (0, jsx_runtime_1.jsx)(react_measure_1.default, { bounds: true, onResize: function (contentRect) {
                var newSize = contentRect.bounds ? (_this.props.direction == Direction.HORIZONTAL ? contentRect.bounds.width : contentRect.bounds.height) : 0;
                if (newSize != _this.state.scrollbarSize) {
                    _this.setState({ scrollbarSize: newSize });
                }
            }, children: function (_a) {
                var measureRef = _a.measureRef;
                return (_this.isScrollbarNeeded(_this.props) ?
                    (0, jsx_runtime_1.jsx)("div", { className: _this.getOutterDivClassName(), style: _this.props.direction == Direction.HORIZONTAL ? { height: exports.SCROLLBAR_SIZE } : { width: exports.SCROLLBAR_SIZE }, ref: function (node) {
                            measureRef(node);
                            _this._outterDiv = node;
                        }, onScroll: function () { return _this.onScroll(); }, children: (0, jsx_runtime_1.jsx)("div", { className: _this.props.direction == Direction.HORIZONTAL ? "rct9k-horizontal-scrollbar-inner" : "rct9k-vertical-scrollbar-inner", style: _this.props.direction == Direction.HORIZONTAL ? { width: _this.getInnerDivSize() } : { height: _this.getInnerDivSize() } }) })
                    : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
            } });
    };
    Scrollbar.defaultProps = {
        scrollPosition: 0,
        direction: Direction.HORIZONTAL,
        hasArrows: false
    };
    return Scrollbar;
}(react_1.default.Component));
exports.Scrollbar = Scrollbar;
var roundDoubleToDecimals = function (value) {
    if (value == 0) {
        return value;
    }
    var roundFactor = Math.pow(10, ROUND_FACTOR);
    return Math.round(value * roundFactor) / roundFactor;
};
//# sourceMappingURL=Scrollbar.js.map